import type { ApiEnvelope } from '@/api/errors';
import { BaseService } from './BaseService';

// Ответ /api/token в старом портале — прямой { token } (без конверта). На всякий случай
// поддерживаем и конвертный вариант.
interface ApiTokenDto {
  readonly token?: string;
}

function extractToken(payload: ApiTokenDto | ApiEnvelope<ApiTokenDto> | undefined): string {
  const direct = (payload as ApiTokenDto | undefined)?.token;
  const enveloped = (payload as ApiEnvelope<ApiTokenDto> | undefined)?.data?.token;
  return direct ?? enveloped ?? '';
}

// API-токен интеграции (api-service /api/token; в каталоге openapi отсутствует — контракт из портала).
class ApiService extends BaseService {
  /** Текущий API-токен. GET — идемпотентно. */
  async getToken(): Promise<string> {
    const response = await this.request<ApiTokenDto | ApiEnvelope<ApiTokenDto>>(
      { method: 'get', url: '/api/token' },
      { idempotent: true },
    );
    return extractToken(response.data);
  }

  /** Регенерация ключа (старый перестаёт работать). Мутация — без повтора. */
  async regenerateToken(): Promise<string> {
    const response = await this.request<ApiTokenDto | ApiEnvelope<ApiTokenDto>>(
      { method: 'put', url: '/api/token', data: {} },
      { retry: false },
    );
    return extractToken(response.data);
  }
}

export const apiService = new ApiService();
